var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    stroke: "#6C5CE7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 12.0833C23.0625 11.4965 22.5868 11.0208 22 11.0208C21.4132 11.0208 20.9375 11.4965 20.9375 12.0833V20.9375H12.0834C11.4966 20.9375 11.0209 21.4132 11.0209 22C11.0209 22.5868 11.4966 23.0625 12.0834 23.0625H20.9375V31.9166C20.9375 32.5034 21.4132 32.9791 22 32.9791C22.5868 32.9791 23.0625 32.5034 23.0625 31.9166V23.0625H31.9167C32.5035 23.0625 32.9792 22.5868 32.9792 22C32.9792 21.4132 32.5035 20.9375 31.9167 20.9375H23.0625V12.0833Z",
    fill: "#6C5CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.be504b000ab3e9d28c8e89cc343b8fd3.svg";
export { ForwardRef as ReactComponent };